<ng-content select="[cuiExpandableItemTriggerFor]" />

@if (isExpanded()) {
  <div class="cui-expandable-item__content" [id]="panelId()">
    <ng-content />
  </div>
}
